module.exports = __webpack_public_path__ + "img/parthner-6.fa556f0c.svg";